/**
 * 
 */
export default class RestApi {
  auth = {
    login: (data) => $app.api.post([ 'admin/auth/login', ]).data(data).with('accesses'),
    info: () => $app.api.get([ 'admin/auth/info', ]),

  }
  
  files = {
    create: (data) => {
      const formData = new FormData()
      $n.each(data, (value, name) => {
        formData.append(name, value)
      })
      return $app.api.post([ 'files', ]).data(formData).config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
  }

  companies = {
    info: () => $app.api.get([ 'companies', ]),
    create: (data) => $app.api.post([ 'companies', ]).data(data),
    delete: (id) => $app.api.delete([ 'companies', id, ]),
    edit: (id, data) => $app.api.patch([ 'companies', id, ]).data(data),
    company: (id) => $app.api.get([ 'companies', id, ]),
    confirmPayment: (id, data) => $app.api.post([ 'companies-tariffs/companies*/do-payment', id, ]).data(data),
    historyPayments: (id) => $app.api.get([ 'companies-tariffs/companies*/payments', id, ]),
    updatePayment: (id, data) => $app.api.patch([ 'company-tariff-payments', id,]).data(data),
    deletePayments: (id) => $app.api.delete([ 'company-tariff-payments', id, ]),
  }

  users = {
    info: () => $app.api.get([ 'admin/users', ]),
    create: (data) => $app.api.post([ 'admin/users', ]).data(data),
    user: (id) => $app.api.get([ 'admin/users', id, ]),
    delete: (id) => $app.api.delete([ 'admin/users', id, ]),
    edit: (id, data) => $app.api.patch([ 'admin/users', id, ]).data(data),
    editPass: (id, data) => $app.api.patch([ 'users*/password', id, ]).data(data),
  }

  roles = {
    roles: () => $app.api.get([ 'admin/auth/roles', ]),
    create: (data) => $app.api.post([ 'admin/auth/roles', ]).data(data),
    delete: (id) => $app.api.delete([ 'admin/auth/roles', id, ]),
  }

  positions = {
    info: () => $app.api.get([ 'admin/accesses', ]),
  }

  permits = {
    info: () => $app.api.get([ 'admin/auth/permits', ]),
  }

  tariffs = {
    info: (id) => $app.api.get([ 'tariffs*', id, ]),
    create: (data) => $app.api.post([ 'tariffs', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'tariffs*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'tariffs*', id, ]),
    attach: (tariffId, companyId, data) => $app.api.post([ 'companies-tariffs/tariffs*/companies*/attach', tariffId, companyId, ]).data(data),
  }
}
